module.exports = __webpack_public_path__ + "img/kleisma2m-m@1.dd2e4f00.webp";